
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { IErrorModel } from '@/models/errors.model';
  import { mapGetters } from 'vuex';
  import Checkbox from '@/components/Core/Checkbox.vue';
  import accountService from '@/services/account.service';
  import { ILoginModel } from '@/models/login.model';
  import { IRequestResultModel } from '@/models/request.model';
  import tokenService from '@/services/token.service';


  @Component({
    components: {
      Checkbox,
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class AcceptTerms extends Vue {
    @Prop({ type: Object as () => ILoginModel })
    public user!: ILoginModel;

    public data() {
      return {
        isAcceptTermsLoading: false,
        hasErrors: false,
        errors: new Array<IErrorModel>(),
        ApprovePrivacyPolicy: false,
        AcceptAccountTerms: false,
        privacyPolicyLink: "",
        EULALink: "",
        privacyPolicyContent: "",
        EULAContent: "",
        cookiePolicyLink: "",
        cookiePolicyContent: "",
        EULAErrorParameters: [],
      };
    };

    public created(): void {
      this.$data.privacyPolicyLink = this.$data.RCEnvironment.VUE_APP_PRIVACY_POLICY_LINK;
      this.$data.EULALink = this.$data.RCEnvironment.VUE_APP_ACCOUNT_TERMS_LINK;
      this.$data.cookiePolicyLink = this.$data.RCEnvironment.VUE_APP_COOKIES_POLICY_LINK;

      this.$data.privacyPolicyContent = "I acknowledge that I have read and understood the practices set out in the <a href=\"" + this.$data.privacyPolicyLink + "\" target=\"_blank\" title=\"Privacy Policy\">Privacy Policy</a> and <a href=\"" + this.$data.cookiePolicyLink + "\" target=\"_blank\" title=\"Cookie Policy\">Cookie Policy</a>.";
      const EULAwording: string = this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STAGING' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TEST' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'PROD' ? 'Terms of Use' : 'Account Terms';
      this.$data.EULAContent = `I accept the <a href="${this.$data.EULALink}" target="_blank" title="${EULAwording}">${EULAwording}</a>.`;

      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STAGING' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TEST' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'PROD') {
        this.$data.EULAErrorParameters = ['Terms of Use'];
      }

       window.addEventListener('beforeunload', () => {
        if (!this.$data.dateOfBirthSaved) {
          this.$cookies.remove("_g2g_identity_");
        }
      })
    }

    public getFilteredErrors(property: string = ''): Array<IErrorModel> {
      return (this.$data.errors as Array<IErrorModel>).filter(error => error.Property == property);
    }

    public updateBooleanValue(parameterName: string, value: boolean): void {
      this.$data[parameterName] = value;
    }

    public confirmTerms(): void {
      if (this.$data.isAcceptTermsLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isAcceptTermsLoading = true;
      this.$data.errors = [];

      if (!this.$data.AcceptAccountTerms) {
        this.$data.errors.push({ Property: "AcceptAccountTerms", ErrorMessage: "ERROR_APPROVE_EULA" });
      }
      if (!this.$data.ApprovePrivacyPolicy) {
        this.$data.errors.push({ Property: "ApprovePrivacyPolicy", ErrorMessage: "ERROR_APPROVE_PRIVACY_POLICY" });
      }

      if (this.$data.errors.length > 0) {
        this.$data.isAcceptTermsLoading = false;
        this.$store.dispatch("updateIsLoading", false);
        return;
      }

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/user/" + this.user.Id_User + "/accept-terms";
      const token: string = this.$cookies.get("_g2g_identity_");

      accountService.post<Object,IRequestResultModel>(this, url, { }, { headers: { Authorization: "Bearer " + token } })
        .then(response => {
          if (response.Success) {
            this.$data.isAcceptTermsLoading = false;
            this.$store.dispatch("updateIsLoading", false);
            tokenService.setToken(this, true);
          } else {
            this.$data.isAcceptTermsLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          }
        })
        .catch(error => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.isAcceptTermsLoading = false;
          this.$data.errors = error.data.ErrorMessages;
        })
    }
  }
